import { render, staticRenderFns } from "./VesselVoyages.vue?vue&type=template&id=15563693&"
import script from "./VesselVoyages.vue?vue&type=script&lang=js&"
export * from "./VesselVoyages.vue?vue&type=script&lang=js&"
import style0 from "./VesselVoyages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VesselVoyages.vue"
export default component.exports